module.exports = __webpack_public_path__ + "img/panchito_waving_fallback-min.34a8c54d.png";